import { refreshOauth2Token } from './refreshOauth2Token'
import { validateTokenForScopes } from './validateTokenForScopes'
import { getAccessTokenInfo } from './getAccessTokenInfo'
import { DEFAULT_OAUTH_SCOPES } from '@learnics/models/src/utils/oauthConfig.mjs'

/**
 * A wrapper around GoogleClassroomService that handles authorization
 * for each of the API calls - specifically for learnics-app.
 */
export async function validateAndRefreshTokenIfNeeded(
  providerId,
  extraScopes,
  userId,
  token = null,
) {
  const validationResult = await validateTokenForScopes(
    providerId,
    extraScopes,
    userId,
    token,
  )
  token ||= validationResult.token

  if (validationResult.needsRefresh) {
    try {
      token = await refreshOauth2Token(providerId)
      validationResult.needsRefresh = false
    } catch (error) {
      console.error(error)
    }
  }

  if (
    validationResult.missingScopes.length === 0 &&
    !validationResult.needsRefresh
  ) {
    console.warn('Loading access token info to ensure the token is valid...')
    try {
      const accessTokenInfo = await getAccessTokenInfo(
        providerId,
        token.access_token,
      )
      // This means we have successfully validated the token.
      console.log('Access token info:', accessTokenInfo)
    } catch (error) {
      console.error(error)
      validationResult.needsRefresh = true
    }
  }

  if (
    validationResult.missingScopes.length > 0 ||
    validationResult.needsRefresh
  ) {
    throw new Error('Missing scopes')
  }
  return token
}
